import styled, { css } from 'styled-components'
import { rem } from 'polished'

import { mediaQueryDown, mediaQueryUp } from 'components/utils/breakpoint'

import { CSSArrow } from 'components/utils/Arrows/Arrow'

import LineCalendarIcon from 'components/Luxkit/Icons/line/LineCalendarIcon'
import Col from 'components/Common/Col'
import ImageWithReservedSpace from 'components/Common/ImageWithReservedSpace'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import InlineGroup from 'components/Common/InlineGroup'
import LineMapMarkerIcon from 'components/Luxkit/Icons/line/LineMapMarkerIcon'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import TextButton from 'components/Luxkit/Button/TextButton'

export const InnerWrapper = styled(PaneBody)`
  display: grid;
  grid-gap: ${rem(18)};

  ${mediaQueryUp.tablet} {
    grid-gap: ${rem(24)};
    grid-template-rows: 1fr min-content;
    grid-template-columns: 1fr ${rem(306)};
  }

  @media print {
    display: grid;
    grid-gap: ${rem(18)};
  }
`

export const OfferInnerWrapper = styled(InnerWrapper)`
  ${mediaQueryDown.mobile} {
    padding-bottom: 0;
  }
`

export const ItemPane = styled(Pane)`
  position: relative;
  min-height: 120px;

  @media print {
    border: 1px solid ${({ theme }) => theme.palette.neutral.five} !important;
  }
`

export const BaseImage = styled(ImageWithReservedSpace)`
  grid-column: 1 / 2 span;

  ${mediaQueryUp.tablet} {
    grid-column: 2;
  }

  @media print {
    grid-column: 2;
  }
`

export const InfoBox = styled.div`
  ${mediaQueryUp.tablet} {
    grid-row: 1;
  }

  @media print {
    grid-row: 1;
  }
`

export const Details = styled(Col)`
  margin-top: ${rem(10)};
`

export const BookingNumber = styled.div<{ cancelled: boolean }>`
  ${({ cancelled }) => cancelled && css`
    text-decoration: line-through;
  `}
`

export const Location = styled(LineMapMarkerIcon)`
  width: ${rem(22)};
`

export const ItemDetails = styled(Pane)`
  grid-column: 1 / 2 span;
  margin-left: ${rem(-16)};
  margin-right: ${rem(-16)};

  ${mediaQueryUp.tablet} {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
`

export const ItemDetail = styled(PaneBody)`
  display: grid;
  grid-template-columns: ${rem(24)} 1fr;
  grid-gap: ${rem(24)};
  align-items: center;

  ${mediaQueryUp.tablet} {
    grid-template-columns: ${rem(24)} 1fr ${rem(152)};
  }

  & + & {
    border-top: 1px solid ${({ theme }) => theme.palette.neutral.five};
  }
`

export const TotalDetail = styled(InlineGroup).attrs({
  horizontal: 'between',
  vertical: 'center',
})`
  padding: ${rem(10)} 0;

  & + & {
    border-top: 1px solid ${({ theme }) => theme.palette.neutral.five};
  }
`

export const InfoCol = styled(Col)`
  > * + * {
    margin-top: ${rem(12)};
  }
`

export const ReservationCol = styled(InfoCol)`
  ${mediaQueryDown.tablet} {
    margin-top: ${rem(12)};
  }
`

export const StyledCalendarIcon = styled(LineCalendarIcon)`
  align-self: center;
`

export const StyledInfoIcon = styled(LineInfoCircleIcon)`
  align-self: flex-start;
`

export const DetailCta = styled(TextButton)`
  align-self: flex-start;
  grid-column: 1 / 2 span;

  ${mediaQueryUp.tablet} {
    grid-column: auto;
  }

  @media print {
    display: none;
  }
`

export const Edge = styled(CSSArrow)`
  align-items: center;
  min-width: ${rem(30)};
  padding-right: ${rem(20)};
  padding-left: ${rem(5)};

  ${mediaQueryUp.desktop} {
    display: flex;
  }

  &::after {
    width: ${rem(10)};
    height: ${rem(10)};
    margin-left: ${rem(-10)};
  }
`

export const Line = styled.div`
  width: ${rem(24)};
  border-top: 1px solid ${({ theme }) => theme.palette.control.black100};
  margin-top: ${rem(8)};
  margin-bottom: ${rem(8)};
`

export const Stack = styled.div`
  & > * + * {
    margin-top: ${rem(20)}
  }

  &.mobile {
    & > * + * {
      margin-top: ${rem(4)}
    }
  }
`

export const BookingInfo = styled.div`
  grid-column: 1 / 2 span;

  ${mediaQueryUp.tablet} {
    grid-row: 2;
    grid-column: auto;
  }
`
